// Per-Page Mode Hooks Framework
(() => {
  'use strict';

  // Hook registry
  const hooks = {
    onModeChange: [],
    onShopMode: [],
    onEatsMode: [],
    onServicesMode: []
  };

  // Page-specific configurations
  const pageConfigs = {
    // Home page hooks
    index: {
      onShopMode: function() {
        // Show shop-specific content, hide eats/services content
        showElements(['.shop-home-content', '.featured-products']);
        hideElements(['.eats-home-content', '.services-home-content']);
      },
      onEatsMode: function() {
        // Show eats-specific content
        showElements(['.eats-home-content']);
        hideElements(['.shop-home-content', '.services-home-content', '.featured-products']);
      },
      onServicesMode: function() {
        // Show services-specific content
        showElements(['.services-home-content']);
        hideElements(['.shop-home-content', '.eats-home-content', '.featured-products']);
      }
    },

    // Product page hooks
    product: {
      onModeChange: function(mode, data) {
        // Update product availability based on mode
        updateProductAvailability(mode);
      },
      onShopMode: function() {
        showAllProducts();
      },
      onEatsMode: function() {
        filterProductsByCategory('food');
      },
      onServicesMode: function() {
        filterProductsByCategory('services');
      }
    },

    // Collection page hooks
    collection: {
      onModeChange: function(mode, data) {
        // Update collection filters based on mode
        updateCollectionFilters(mode);
      }
    },

    // Search page hooks
    search: {
      onModeChange: function(mode, data) {
        // Update search filters and results
        updateSearchFilters(mode);
      }
    },

    // Cart page hooks
    cart: {
      onModeChange: function(mode, data) {
        // Update cart behavior based on mode
        updateCartBehavior(mode);
      }
    }
  };

  // Utility functions
  function showElements(selectors) {
    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.style.display = '';
        el.removeAttribute('hidden');
      });
    });
  }

  function hideElements(selectors) {
    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.style.display = 'none';
        el.setAttribute('hidden', 'true');
      });
    });
  }

  function updateProductAvailability(mode) {
    // Example: Update product availability indicators based on mode
    const availabilityEls = document.querySelectorAll('[data-availability]');
    availabilityEls.forEach(el => {
      const availability = el.dataset.availability;
      // Mode-specific availability logic
      if (mode === 'eats' && availability === 'food-only') {
        el.style.display = '';
      } else if (mode === 'services' && availability === 'service-only') {
        el.style.display = '';
      } else if (mode === 'shop') {
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
  }

  function showAllProducts() {
    // Show all products on product pages
    const products = document.querySelectorAll('.product-item, .product-card');
    products.forEach(product => {
      product.style.display = '';
    });
  }

  function filterProductsByCategory(category) {
    // Filter products by category on product/collection pages
    const products = document.querySelectorAll('.product-item, .product-card');
    products.forEach(product => {
      const productCategory = product.dataset.category || product.dataset.tags;
      if (productCategory && productCategory.includes(category)) {
        product.style.display = '';
      } else {
        product.style.display = 'none';
      }
    });
  }

  function updateCollectionFilters(mode) {
    // Update collection filters based on mode
    const filterEls = document.querySelectorAll('.collection-filter');
    filterEls.forEach(filter => {
      const filterMode = filter.dataset.mode;
      if (!filterMode || filterMode === mode) {
        filter.style.display = '';
      } else {
        filter.style.display = 'none';
      }
    });
  }

  function updateSearchFilters(mode) {
    // Update search filters based on mode
    if (window.searchGallery && window.searchGallery.updateFiltersForMode) {
      window.searchGallery.updateFiltersForMode(mode);
    }
  }

  function updateCartBehavior(mode) {
    // Update cart behavior based on mode
    if (mode === 'eats') {
      // Enable food delivery options
      showElements(['.delivery-options', '.food-prep-time']);
    } else if (mode === 'services') {
      // Enable service scheduling
      showElements(['.service-scheduling', '.booking-calendar']);
    } else {
      // Standard shop cart
      hideElements(['.delivery-options', '.food-prep-time', '.service-scheduling', '.booking-calendar']);
    }
  }

  // Hook registration API
  window.PageHooks = {
    // Register a hook
    register: function(type, callback) {
      if (hooks[type]) {
        hooks[type].push(callback);
      }
    },

    // Register page-specific hooks
    registerPage: function(pageType, hookConfig) {
      if (pageConfigs[pageType]) {
        Object.assign(pageConfigs[pageType], hookConfig);
      } else {
        pageConfigs[pageType] = hookConfig;
      }
    },

    // Execute hooks
    execute: function(type, ...args) {
      // Execute general hooks
      hooks[type].forEach(callback => {
        try {
          callback.apply(null, args);
        } catch (e) {
        }
      });

      // Execute page-specific hooks
      const currentPage = getCurrentPageType();
      const pageConfig = pageConfigs[currentPage];
      if (pageConfig && pageConfig[type]) {
        try {
          pageConfig[type].apply(null, args);
        } catch (e) {
        }
      }
    }
  };

  // Get current page type
  function getCurrentPageType() {
    const template = document.documentElement.dataset.template;
    if (template === 'index') return 'index';
    if (template === 'product') return 'product';
    if (template === 'collection') return 'collection';
    if (template === 'search') return 'search';
    if (template === 'cart') return 'cart';
    return 'other';
  }

  // Initialize
  function init() {
    // Listen for mode changes
    document.addEventListener('veda:mode:changed', function(e) {
      const { mode, previousMode, initial } = e.detail;

      // Execute general mode change hooks
      window.PageHooks.execute('onModeChange', mode, { previousMode, initial });

      // Execute mode-specific hooks
      if (mode === 'shop') {
        window.PageHooks.execute('onShopMode');
      } else if (mode === 'eats') {
        window.PageHooks.execute('onEatsMode');
      } else if (mode === 'services') {
        window.PageHooks.execute('onServicesMode');
      }
    });
  }

  // Auto-initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();